import { FileText, Download } from "lucide-react";
import { fileSize, mediaUrl } from "@/lib/media";

export const MediaContent = ({ m }) => {
  const { kind, filename, size, mime } = m.media;
  const url = mediaUrl(m.id);
  if (kind === "image") {
    return (
      <a href={url} target="_blank" rel="noreferrer" data-testid={`media-image-${m.id}`} className="block -mx-1.5 -mt-0.5 mb-1">
        <img src={url} alt={filename} loading="lazy" className="rounded-lg max-h-72 w-full object-cover bg-slate-100" />
      </a>
    );
  }
  if (kind === "audio") {
    return <audio data-testid={`media-audio-${m.id}`} controls preload="metadata" src={url} className="h-10 w-64 my-1" />;
  }
  return (
    <a href={url} target="_blank" rel="noreferrer" data-testid={`media-document-${m.id}`}
      className="flex items-center gap-3 bg-black/5 hover:bg-black/10 transition-colors rounded-lg px-3 py-2.5 my-1 min-w-56">
      <span className="w-9 h-9 rounded-md bg-red-500 text-white grid place-items-center shrink-0"><FileText size={17} /></span>
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-semibold truncate">{filename}</span>
        <span className="block text-[11px] opacity-70 uppercase">{(mime || "").split("/").pop()} · {fileSize(size)}</span>
      </span>
      <Download size={15} className="opacity-60" />
    </a>
  );
};
